/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completeSquareWorkflow} from '../api'

export const useMutationCompleteSquareWorkflow = createReactQueryMutationHook('completeSquareWorkflow', completeSquareWorkflow)
